import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { PAY_URL } from "../../../BaseURL";
import toast from "react-hot-toast";

export const getUserCategory = createAsyncThunk('/category/getUserCategory',
    async () => {
        try {
            const myurl = `${PAY_URL}/user/get-category`;

            const response = await axios({
                method: 'get',
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const data = response.data;
            console.log("data",data);
            // console.log(data, "response");

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data.message);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error;
        }
    })

const getUserCategorySlice = createSlice({
  name: "userCategory",
  initialState: {
    categories: [], // <-- store array here
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserCategory.fulfilled, (state, action) => {
        state.categories = action.payload.data || []; // <-- store data array
        state.loading = false;
        state.error = null;
      })
      .addCase(getUserCategory.rejected, (state, action) => {
        state.categories = [];
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default getUserCategorySlice.reducer;
